import Notification from './Notification';

// export types
export type { NotificationProps } from './Notification';

// export components
export { Notification };
export default Notification;
